import React, { ReactNode, FunctionComponent } from 'react';
import classnames from 'classnames';

// components
import Close from 'dibs-vg/dist/react/close';

// styles
import styles from './main.scss';

type SearchTagProps = {
    isActive?: boolean;
    disabled?: boolean;
    onDelete?: () => void;
    dataTn?: string;
    children: ReactNode;
    hasDeleteButton?: boolean;
};
export const SearchTag: FunctionComponent<SearchTagProps> = props => {
    const {
        isActive = true,
        disabled = false,
        onDelete = () => {},
        dataTn,
        children,
        hasDeleteButton = true,
    } = props;

    const tagClassName = classnames(styles.searchTag, {
        [styles.searchTagEnabled]: !disabled,
        [styles.searchTagActive]: isActive && !disabled,
    });
    const deleteClassName = classnames(styles.deleteButton, {
        [styles.deleteButtonEnabled]: !disabled,
    });
    const labelClassNames = classnames(styles.searchTagLabel, {
        [styles.noDeleteButton]: !hasDeleteButton,
    });
    const deleteClick = disabled ? undefined : onDelete;
    return (
        <div className={styles.searchTagWrapper}>
            <div className={tagClassName} data-tn={dataTn}>
                <div className={labelClassNames}>{children}</div>
                {hasDeleteButton && (
                    <div className={deleteClassName} onClick={deleteClick}>
                        <Close className={styles.closeIcon} />
                    </div>
                )}
            </div>
        </div>
    );
};
